module.exports = __webpack_public_path__ + "img/00_base_1210mk2_VG+.361b7135.png";